import { Form, Select, Button, DatePicker } from 'antd';
import { FormInstance } from 'antd/es/form';
import FormSection from '../FormSection';
import Calendar from '../svg/Calendar';
import CurvDown from '../svg/CurvDown';

const { Option } = Select;

interface IssuesProps {
  form: FormInstance;
  isViewMode?: boolean;
}

const Issues: React.FC<IssuesProps> = ({ form, isViewMode }) => {
  const isView = isViewMode || new URLSearchParams(window.location.search).get('view') === 'true';
  const categoryOptions = [
    'All',
    'Benefits/Pay/Privilege',
    'Equipment/supplies',
    'Physical Abuse',
    'Supervision',
    'Verbal Abuse',
    'Other'
  ];

  const issueOptions = [
    'Contract not renewed',
    'Denied a raise',
    'Denied breaks/lunch',
    'Denied comp. time',
    'Denied family leave',
    'Denied overtime',
    'Denied paid holidays',
    'Denied reassignment/transfer',
    'Denied training',
    'Denied vacation time',
    'Denied your cash award',
    'Denied your promotion',
    'Involuntary transfers',
    'Made you work overtime without pay',
    'Not allowed to have visitors',
    'Not allowed to make/receive phone calls',
    'Not given a parking space',
    'Not invited to office meetings',
    'Removed your driving privilege',
    'Denied a company car',
    'Denied a company credit card',
    'Denied adequate supplies',
    'Denied computer/equipment',
    'Did not assign an office',
    'Refused to provide a clothing allowance',
    'Hit you/inflicted injury to your person',
    'Threw work at you',
    'Threw your food/drinks away',
    'Threw your work product in the trash',
    'Angrily chastised for filing complaint',
    'Cautioned/punished for laughing/talking loudly',
    'Cautioned/punished for reading in the office'
  ];

  return (
    <div className="flex flex-col w-full h-full issues-page-container">
      <style dangerouslySetInnerHTML={{
        __html: `
        .issues-page-container .ant-form-item-label {
          min-height: 30px !important;
          margin-bottom: 8px !important;
        }
        @media (max-width: 1024px) {
          .issues-page-container .ant-form-item-label {
            margin-bottom: 0px !important;
          }
        }
        .issues-page-container .ant-picker,
        .issues-page-container .ant-select-selector {
          padding: 13px 12px !important;
        }
        .issues-page-container .ant-picker .ant-picker-suffix svg {
          width: 13px !important;
          height: 15px !important;
        }
        @media (min-width: 1024px) {
          .issues-page-container .ant-picker,
          .issues-page-container .ant-select-selector {
            padding: 14px 19px !important;
          }
          .issues-page-container .ant-picker .ant-picker-suffix svg {
            width: 18px !important;
            height: 18px !important;
          }
          // .issues-page-container .lg-label-hidden .ant-form-item-label {
          //   visibility: hidden !important;
          // }
        }
        .issues-page-container .flex.items-center.gap-4 {
          margin-bottom: 37px !important;
        }
        .issues-page-container .date-field .ant-form-item-explain-error {
          margin-top: 14px !important;
        }
        .issues-page-container .issue-field .ant-form-item-explain-error{
          margin-top: 28px !important;
        }
          .issues-page-container .category-field .ant-form-item-explain-error{
          margin-top: 28px !important;
        }
      `}} />
      <FormSection title="Issues" columns={1}>
        <div>
          <div className="flex items-center justify-between mb-[25px] gap-[34px] md:gap-0">
            <h3 className="font-['Lexend',sans-serif] text-[14px] lg:text-[18px] font-medium text-[#1F2A37] leading-[29px] m-0">
              Issues - What was done by the accused? (select up to 3 items)
            </h3>
            <Form.List name={['issues_info', 'issues']}>
              {(fields, { add }) => (
                <Button
                  type="text"
                  onClick={() => {
                    if (fields.length < 3) {
                      add();
                    }
                  }}
                  disabled={fields.length >= 3 || isViewMode}
                  className="flex items-center gap-2 text-[#4682B4] font-['Lexend',sans-serif] p-0 disabled:opacity-50"
                >
                  <span className="text-[18px] leading-none">+</span> Add More
                </Button>
              )}
            </Form.List>
          </div>

          <Form.List name={['issues_info', 'issues']}>
            {(fields, { remove }) => (
              <div className="flex flex-col gap-0 w-full">
                {fields.map(({ key, name, ...restField }) => (
                  <div key={key} className="flex flex-row items-start w-full mb-[33px] lg:mb-[30px]">
                    {/* Number */}
                    <div className="w-8 flex justify-center pt-[10px] lg:pt-[38px] mr-[8px] lg:mr-[18px]">
                      <span className="font-['Lexend',sans-serif] text-[12px] lg:text-[18px] text-[#1F2A37A1] font-medium pt-[30px] lg:pt-[12px]">
                        {String(name + 1).padStart(2, '0')}
                      </span>
                    </div>

                    <div className="flex-1 flex flex-col lg:flex-row gap-[21px] lg:gap-[60px]">
                      {/* Mobile Row 1: Category + Delete */}
                      <div className="flex flex-row items-end gap-[10px] lg:gap-4 w-full lg:w-auto lg:contents">
                        <div className="flex-1 lg:flex-1">
                          <Form.Item
                            {...restField}
                            name={[name, 'category']}
                            label="Category"
                            className={`mb-0 w-full category-field ${name > 0 ? 'lg-label-hidden' : ''}`}
                            rules={[{ required: true, message: 'Please select category' }]}
                          >
                            <Select placeholder="Select" suffixIcon={<CurvDown className="pt-[10px] md:pt-[14px]" />}>
                              {categoryOptions.map(option => (
                                <Option key={option} value={option}>{option}</Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                        <div className="lg:hidden w-10 flex justify-start lg:justify-center lg:pb-[12px]">
                          <button
                            onClick={() => {
                              if (!isView) {
                                remove(name);
                              }
                            }}
                            disabled={isView}
                            type="button"
                            style={isView ? { pointerEvents: 'none', opacity: 0.3, cursor: 'not-allowed' } : undefined}
                            className="p-1 text-[#6FB6F2] hover:text-red-500 transition-colors border-none bg-transparent cursor-pointer pt-[12px] disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none"
                          >
                            <svg width="20" height="22" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-[12px] h-[13px] lg:w-[18px] lg:h-[20px] stroke-current">
                              <path d="M1 4h14M2 4v11a2 2 0 002 2h8a2 2 0 002-2V4M5 4V2a1 1 0 011-1h4a1 1 0 011 1v2M6.5 8v5M9.5 8v5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </button>
                        </div>
                      </div>

                      {/* Mobile Row 2: Issue + Date */}
                      <div className="flex flex-row gap-[20px] lg:gap-4 w-[87%] lg:w-auto lg:contents">
                        <div className="flex-1 lg:flex-1">
                          <Form.Item
                            {...restField}
                            name={[name, 'issue']}
                            label="Issue"
                            className={`mb-0 issue-field  ${name > 0 ? 'lg-label-hidden' : ''}`}
                            rules={[{ required: true, message: 'Please select issue' }]}
                          >
                            <Select showSearch placeholder="Select Issue" suffixIcon={<CurvDown className="pt-[10px] md:pt-[14px]" />}>
                              {issueOptions.map(option => (
                                <Option key={option} value={option}>{option}</Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>

                        <div className="flex-1 lg:flex-1">
                          <Form.Item
                            {...restField}
                            name={[name, 'date']}
                            label="Date"
                            className={`mb-0 date-field ${name > 0 ? 'lg-label-hidden' : ''}`}
                            rules={[{ required: true, message: 'Please select date' }]}
                          >
                            <DatePicker
                              placeholder="Select Date"
                              format="DD-MM-YYYY"
                              suffixIcon={<Calendar />}
                              className="w-full"
                              inputReadOnly
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </div>

                    {/* Desktop Delete */}
                    <div className="hidden lg:flex w-10 flex justify-center pt-[38px] ml-[31px]">
                      <button
                        onClick={() => {
                          if (!isView) {
                            remove(name);
                          }
                        }}
                        disabled={isView}
                        type="button"
                        style={isView ? { pointerEvents: 'none', opacity: 0.3, cursor: 'not-allowed' } : undefined}
                        className="p-1 text-[#6FB6F2] hover:text-red-500 transition-colors border-none bg-transparent cursor-pointer pt-[12px] disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none"
                      >
                        <svg width="20" height="22" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-[18px] h-[20px] stroke-current">
                          <path d="M1 4h14M2 4v11a2 2 0 002 2h8a2 2 0 002-2V4M5 4V2a1 1 0 011-1h4a1 1 0 011 1v2M6.5 8v5M9.5 8v5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </Form.List>
        </div>
      </FormSection>
    </div>
  );
};

export default Issues;
